__turbopack_context__.v({
  "className": "fontawesome6probrands_bd4a90a-module__6Nazrq__className",
  "variable": "fontawesome6probrands_bd4a90a-module__6Nazrq__variable",
});
